import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { db } from "../lib/firebaseConfig";

export const useGetAllMessages = () => {
  const domain = window.location.host;
  const [allMessages, setAllMessages] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(
      query(
        collection(db, "chatUsers", domain, "messages"),
        orderBy("timestamp")
      ),
      (snapshot) => {
        setAllMessages(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            messages: doc.data(),
          }))
        );
      }
    );
    return unsub;
  }, [domain]);

  return { allMessages };
};

export const useGetMessages = () => {
  const cookies = new Cookies();
  const currentUserId = cookies.get("uuid");
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(
      query(
        collection(db, "chatUsers", currentUserId, "messages"),
        orderBy("timestamp")
      ),
      (snapshot) => {
        setMessages(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            messages: doc.data(),
          }))
        );
      }
    );
    return unsub;
  }, [currentUserId]);

  return { messages };
};

export const usePostMessage = () => {
  const postMessage = async ({ chatMessage, sender, receiver, combineId }) => {
    try {
      await addDoc(collection(db, "chatUsers", receiver, "messages"), {
        messageUserId: sender,
        message: chatMessage,
        timestamp: new Date(),
      });

      await addDoc(collection(db, "chatUsers", sender, "messages"), {
        messageUserId: sender,
        message: chatMessage,
        timestamp: new Date(),
      });
    } catch (error) {
      console.log(error);
    }
  };
  return { postMessage };
};
